import React from 'react';

const combineList = [
  {
    title: '🪙 Fun Token',
    description:
      'Diperoleh dari Daily Quest “Embers of Rebirth”, login reward, atau event. Digunakan untuk membuat Legacy Shard. Bisa dijual antar pemain.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/FUN%20TOKEN_Uivqd7NwB?updatedAt=1761274723123',
  },
  {
    title: '💠 Legacy Shard',
    description:
      'Dibuat dari 5 Fun Token. Berfungsi sebagai bahan crafting untuk Legend Core. Item bound, bisa didapat juga dari event tertentu.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/legacyshard_Ewktuu9IT?updatedAt=1761274758920',
  },
  {
    title: '🔱 Legend Core',
    description:
      'Hasil kombinasi dari 3 Legacy Shard + 2 Fun Token. Bahan utama dalam pembuatan Phoenix Catalyst.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/legend-core_gBJUZ-8Su?updatedAt=1761274917150',
  },
  {
    title: '🔥 Flame of Rebirth',
    description:
      'Drop dari monster biasa (3–5% chance). Item bound dan hilang otomatis dalam 24 jam setelah diperoleh. Bisa digunakan untuk membuat Phoenix Catalyst atau ditukar menjadi Cash Coin.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/flame-of-rebirth_mjyknEeRh?updatedAt=1761275041829',
  },
  {
    title: '🔮 Phoenix Catalyst',
    description:
      'Dibuat dari 2 Legend Core + 1 Flame of Rebirth. Tahap sebelum Phoenix Coin. Bound item.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/catalyst_AOixvMjpf?updatedAt=1761274971794',
  },
  {
    title: '💎 Phoenix Coin',
    description:
      'Item booty tingkat tinggi. Diperoleh dari 1 Phoenix Catalyst + 1 Flame of Rebirth. Dapat dikombinasikan menjadi Phoenix Gamble Box. Tidak langsung menghasilkan Cash Coin.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/phoenix-coin_e0ycEOK7L?updatedAt=1761275002192',
  },
  {
    title: '🎲 Phoenix Gamble Box',
    description:
      'Dibuat dari 3 Phoenix Coin + 1 Flame of Rebirth (35% keberhasilan). Berisi hadiah langka dan item eksklusif dengan nilai tinggi.',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/phoenix-gamble-box_mtYMQcO-C?updatedAt=1761544316024',
  },
];

const npcCombine = [
  {
    recipe: '🪙 Fun Token ×5',
    result: '💠 Legacy Shard',
    chance: '100%',
  },
  {
    recipe: '💠 Legacy Shard ×3 + 🪙 Fun Token ×2',
    result: '🔱 Legend Core',
    chance: '80%',
  },
  {
    recipe: '🔱 Legend Core ×2 + 🔥 Flame of Rebirth ×1',
    result: '🔮 Phoenix Catalyst',
    chance: '50%',
  },
  {
    recipe: '🔮 Phoenix Catalyst ×1 + 🔥 Flame of Rebirth ×1',
    result: '💎 Phoenix Coin',
    chance: '10%',
  },
  {
    recipe: '💎 Phoenix Coin ×3 + 🔥 Flame of Rebirth ×1',
    result: '🎲 Phoenix Gamble Box',
    chance: '35%',
  },
];

const gambleRewards = [
  {
    title: 'Cash Coin Capsule +1000',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cc-1000_qIepgEGBT?updatedAt=1761545047845',
  },
  {
    title: 'Cash Coin Capsule +1500',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cc-1500_vkjXf11Ip?updatedAt=1761545087077',
  },
  {
    title: 'Cash Coin Capsule +2000',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cc-2000_X9HgauQDt?updatedAt=1761545119529',
  },
  {
    title: 'Cash Coin Capsule +5000',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cc-5000_8nhGMcDAL?updatedAt=1761545162830',
  },
  {
    title: 'Cash Coin Capsule +10000',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cc-10000_bYJKSvsEf?updatedAt=1761545203823',
  },
  {
    title: 'Phoenix Catalyst',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/phoenix-catalyst_BTKUD2jMV?updatedAt=1761545283137',
  },
  {
    title: 'Lucky Beads',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/lucky-beads_-2EalilSo?updatedAt=1761545317704',
  },
  {
    title: 'SLGS Tier 10',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/SLGS-10_bVir0rJeu?updatedAt=1761545375026',
  },
  {
    title: 'SLGS Tier 11',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/slgs-11_In1qKksb4?updatedAt=1761545408810',
  },
  {
    title: 'Ticket Cartella Rock Weapon +5',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cartella-rock-5_g-U5tbrWd?updatedAt=1761545453466',
  },
  {
    title: 'Ticket Screamed Of The Dragon Weapon +4',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/screamed-weapon-4_4ZSlZDasw?updatedAt=1761545492177',
  },
  {
    title: 'Ravid Cora Armor [ES] Lucky Box',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/cora-armor-es_m36mvCkei?updatedAt=1761545644039',
  },
  {
    title: 'Ravid Bellato Armor [ES] Lucky Box',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/bell-armor-es_ftsb3lZAQ?updatedAt=1761545584355',
  },
  {
    title: 'Optimus Prime Armor [ES] Lucky Box',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/acc-armor-es_afl2JiiR4?updatedAt=1761545682508',
  },
  {
    title: 'Restoper Hole Ring',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/restoper-hole-ring_sbVQdzSG8?updatedAt=1761545777016',
  },
  {
    title: 'Restoper Hole Amulet',
    img: 'https://ik.imagekit.io/alfathars/LEGACY%20AND%20PHOENIX%20SYSTEM/PHOENIX%20GAMBLE%20BOX/restoper-hole-amulet_eh7g78hDO?updatedAt=1761545813051',
  },
];

function CombineInfo() {
  return (
    <section className="py-16 px-4 md:px-12 bg-gradient-to-b from-gray-900 via-gray-950 to-black text-gray-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center text-orange-400">
          ⚗️ Sistem Kombinasi — Legacy & Phoenix
        </h2>

        <p className="text-center text-sm text-gray-400 mb-10 max-w-2xl mx-auto">
          Semua kombinasi dilakukan melalui <strong>NPC Hero</strong>. Siapkan bahan sesuai resep dan perhatikan
          tingkat keberhasilan. Setiap tingkat kombinasi memiliki peluang berbeda.
        </p>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {combineList.map((item, i) => (
            <div
              key={i}
              className="bg-gray-800/60 border border-gray-700 rounded-xl overflow-hidden shadow hover:shadow-orange-600/30 transition transform hover:-translate-y-1"
            >
              <img src={item.img} alt={item.title} className="w-full h-48 object-contain bg-black/40 p-2" />
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-2 text-orange-300">{item.title}</h3>
                <p className="text-sm text-gray-300 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Combination Table */}
        <div className="mt-14 bg-gray-800/60 border border-gray-700 rounded-xl p-6 shadow-lg">
          <h3 className="text-xl font-bold text-orange-400 mb-4 text-center">
            🧩 Combination Info — NPC Hero
          </h3>

          <div className="overflow-x-auto">
            <table className="min-w-full text-sm border border-gray-700 rounded-lg overflow-hidden">
              <thead className="bg-gray-700 text-gray-100">
                <tr>
                  <th className="py-2 px-3 text-left">Bahan</th>
                  <th className="py-2 px-3 text-left">Hasil</th>
                  <th className="py-2 px-3 text-left">Persentase</th>
                </tr>
              </thead>
              <tbody>
                {npcCombine.map((row, i) => (
                  <tr key={i} className="border-t border-gray-700 hover:bg-gray-700/30 transition">
                    <td className="py-2 px-3">{row.recipe}</td>
                    <td className="py-2 px-3 text-orange-300">{row.result}</td>
                    <td className="py-2 px-3">{row.chance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="text-xs text-gray-500 mt-4 text-center italic">
            * Semakin tinggi tingkat kombinasi, semakin rendah tingkat keberhasilannya. Gunakan dengan bijak dan siapkan bahan cadangan. Umumnya hanya Flame of Rebirth yang hancur dalam kombinasi.
          </p>
        </div>

        {/* Flow Diagram */}
        <div className="mt-12 text-center">
          <h3 className="text-xl font-semibold text-orange-400 mb-2">🔄 Alur Kombinasi</h3>
          <p className="text-gray-400 text-sm">
            Fun Token → Legacy Shard → Legend Core → Flame of Rebirth → Phoenix Catalyst → Phoenix Coin → Phoenix Gamble Box
          </p>
          <div className="flex flex-wrap justify-center items-center gap-2 mt-4 text-orange-300 text-sm">
            <span>🪙 Fun Token</span>
            <span>➡️</span>
            <span>💠 Legacy Shard</span>
            <span>➡️</span>
            <span>🔱 Legend Core</span>
            <span>➡️</span>
            <span>🔥 Flame of Rebirth</span>
            <span>➡️</span>
            <span>🔮 Phoenix Catalyst</span>
            <span>➡️</span>
            <span>💎 Phoenix Coin</span>
            <span>➡️</span>
            <span>🎲 Phoenix Gamble Box</span>
          </div>
        </div>

        {/* Gamble Box Reward Section */}
        <div className="mt-16 bg-gray-800/60 border border-gray-700 rounded-xl p-6 shadow-lg">
          <h3 className="text-xl font-bold text-orange-400 mb-6 text-center">
            🎲 Phoenix Gamble Box — Isi Hadiah
          </h3>
          <p className="text-sm text-gray-400 text-center mb-8">
            Phoenix Gamble Box berisi berbagai item langka dan hadiah eksklusif. Berikut daftar kemungkinan
            hadiahnya:
          </p>

          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {gambleRewards.map((item, index) => (
              <div
                key={index}
                className="bg-gray-900/60 border border-gray-700 rounded-xl overflow-hidden text-center hover:shadow-lg hover:shadow-orange-700/30 transition transform hover:-translate-y-1"
              >
                <img src={item.img} alt={item.title} className="w-full h-40 object-contain bg-black/40 p-2" />
                <div className="p-3 text-gray-200 text-sm">{item.title}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-500 mt-12">
          © RF FUN SERVER REBORN — Sistem Ekonomi & Crafting dirancang oleh Master Dev Team.
        </p>
      </div>
    </section>
  );
}

export default CombineInfo;
